import React, { useState } from 'react';
import FormButtonGroup from '../../common/FormButtonGroup';
import KwPanel from '../../common/KwPanel';
import SlideoutLayout from '../../layout/slideout/SlideoutLayout';
import { steamDisableKeysUri } from '../../../util/steamUtils';
import Button from '../../common/Button';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';
import { setSteamKeysAsDisabled } from '../../../api/keyCodeApi';

export interface DisableOnSteamProps {
  id: string | undefined;
  done: () => void;
  cancel: () => void;
}

function DisableOnSteam({ id, done, cancel }: DisableOnSteamProps) {
  const { t } = useTranslation();
  const [type, setType] = useState<string>();
  const [reason, setReason] = useState<string>();

  const handleDisableOnSteam = () => {
    if (id) (window as any).location = steamDisableKeysUri(id, type, reason);
    done();
  };

  const handleMarkAsDisabled = async () => {
    try {
      if (id) await setSteamKeysAsDisabled(id);
      toast.success(t('Steam keys marked as disabled'));
      done();
    } catch (e: any) {
      toast.error(e.message || t('Failed to mark keys as disabled'));
    }
  };

  return (
    <SlideoutLayout
      title={t('Disable on Steam')}
      cancel={cancel}
      bar={
        <Button
          className="btn btn-primary"
          isDisabled={!type || (type === 'All' && !reason)}
          onClick={handleDisableOnSteam}
          text={t('Disable on Steam')}
        />
      }
    >
      <KwPanel className="mb-4">
        <header className="mb-2">
          <h2 className="no-margin">
            {t('Disable automatically on Steam with automation tool')}
          </h2>
        </header>
        <FormButtonGroup
          name="type"
          label={t('Ban type')}
          buttons={[
            { value: 'All', text: t('Ban all keys') },
            { value: 'Unredeemed', text: t('Ban only unredeemed keys') },
          ]}
          onChange={(btn: any) => setType(btn.value)}
          value={type}
        />
        {type === 'All' && (<>
          <FormButtonGroup
            name="reason"
            label={t('Reason')}
            buttons={[
              { value: 'Fraud', text: t('Revoke keys for Fraud') },
              { value: 'Beta', text: t('Revoke Beta keys') },
              { value: 'Refund', text: t('Revoke keys for Refunds') },
            ]}
            onChange={(btn: any) => setReason(btn.value)}
            value={reason}
          />
        </>
        )}
      </KwPanel>
      <KwPanel className="mb-4">
        <header className="mb-2">
          <h2 className="no-margin">{t('Manually disable on Steam')}</h2>
        </header>
        <Button
          className="btn btn-primary"
          text={t('Mark as disabled on Steam')}
          onClick={handleMarkAsDisabled}
        />
      </KwPanel>
    </SlideoutLayout>
  );
}

export default DisableOnSteam;
